export enum ProductPriceSchemeType {
  Main = 1,
  Campaign = 2,
  Procurement = 3,
  Store = 4
}

(ProductPriceSchemeType as any).__typeName = 'ProductPriceSchemeType';